import React from "react"
import getMuiTheme from "material-ui/styles/getMuiTheme"
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider"
import { amber600, blueGrey500, grey700 } from "material-ui/styles/colors"
import autobind from "class-autobind"
import TextProgressSnackbar from "../common/TextProgressSnackbar"
import { IAccountManagerFESettings } from "../../models/data/account_manager/AccountManagerFESettings"
import { isMobile } from "react-device-detect"

interface IState {
}

interface IProps {
  leftContainer: object,
  rightContainer: object,
  loading: string,
	frontEndSettings: IAccountManagerFESettings,
}

export default class RegistrationLayout extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
    }
    autobind(this)
  }

  render() {
    let muiTheme = getMuiTheme({
      palette: {
        primary1Color: blueGrey500,
        accent1Color: amber600,
        textColor: grey700
      },
      flatButton: {
        primaryTextColor: amber600,
        secondaryTextColor: blueGrey500
      }
    })

    if(this.props.frontEndSettings){
      muiTheme = getMuiTheme({
        palette: {
          primary1Color: this.props.frontEndSettings.UISettings.PrimaryColor,
          accent1Color: this.props.frontEndSettings.UISettings.AccentColor,
          textColor: this.props.frontEndSettings.UISettings.TextColor,
        },
        flatButton: {
          primaryTextColor: this.props.frontEndSettings.UISettings.AccentColor,
          secondaryTextColor: this.props.frontEndSettings.UISettings.TextColor,
        }
      })
    }

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="registration-main-container">
          <div className="registration-left-container">
            <div style={{ padding: isMobile ? 20 : 100 }}>
              <img src={this.props.frontEndSettings ? this.props.frontEndSettings.UISettings.LoginLogoURL : null} style={{ width: 150 }} />
            </div>
            <div
              className={isMobile ? null : "registration-left-container-content"}
              style={{ padding: isMobile ? 20 : 100, position: isMobile ? null : "absolute" }}
            >
              {this.props.leftContainer}
            </div>
          </div>
          <div className="registration-right-container" style={{backgroundColor: this.props.frontEndSettings ? this.props.frontEndSettings.UISettings.AccentColor : null}}>
            {this.props.rightContainer}
          </div>
          {this.props.loading &&
            <TextProgressSnackbar
              content={{ progressText: this.props.loading }}
              close={() => { }}
            />
          }
        </div>
      </MuiThemeProvider>
    )
  }
}